import React from 'react'

const Svg = ({ size = 16, strokeWidth = 2, children, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} aria-hidden="true" {...props}>
        {children}
    </svg>
)

export const SearchIcon = (props) => <Svg {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></Svg>

export const SunIcon = (props) => (
    <Svg {...props}>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </Svg>
)

export const MoonIcon = (props) => <Svg {...props}><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" /></Svg>

export const HelpIcon = (props) => (
    <Svg size={20} strokeWidth={1.8} {...props}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6M12 17v.5" />
    </Svg>
)

export const BellIcon = (props) => (
    <Svg size={20} strokeWidth={1.8} {...props}>
        <path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2h-15z" />
        <path d="M10 20a2 2 0 0 0 4 0" />
    </Svg>
)

export const TasksIcon = (props) => (
    <Svg size={20} strokeWidth={1.8} {...props}>
        <rect x="4" y="4" width="16" height="16" rx="3.5" />
        <path d="m8.5 12 2.5 2.5 4.5-5" />
    </Svg>
)

export const ChevronDownIcon = (props) => <Svg {...props}><path d="m6 9 6 6 6-6" /></Svg>

export const ChevronRightIcon = (props) => <Svg size={14} strokeWidth={2.4} {...props}><path d="m9 6 6 6-6 6" /></Svg>

export const ChevronLeftIcon = (props) => <Svg size={14} {...props}><path d="m15 18-6-6 6-6" /></Svg>

export const MenuIcon = (props) => <Svg size={20} {...props}><path d="M4 7h16M4 12h16M4 17h16" /></Svg>

export const CloseIcon = (props) => <Svg size={20} {...props}><path d="M6 6l12 12M18 6 6 18" /></Svg>

export const PlusIcon = (props) => <Svg size={14} strokeWidth={2.4} {...props}><path d="M12 5v14M5 12h14" /></Svg>

export const ProfileIcon = (props) => (
    <Svg strokeWidth={1.8} {...props}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" />
    </Svg>
)

export const PlanIcon = (props) => (
    <Svg strokeWidth={1.8} {...props}>
        <path d="m12 3 2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" />
    </Svg>
)

export const SettingsIcon = (props) => (
    <Svg strokeWidth={1.8} {...props}>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </Svg>
)

export const LogoutIcon = (props) => <Svg strokeWidth={1.8} {...props}><path d="M15 4h4v16h-4M10 8l-4 4 4 4M6 12h10" /></Svg>

export const AgencyIcon = (props) => <Svg strokeWidth={1.8} {...props}><path d="M7 7h11l-3-3M17 17H6l3 3" /></Svg>

export const CheckIcon = (props) => <Svg size={18} strokeWidth={2.4} {...props}><path d="m5 12 5 5L19 8" /></Svg>

export const HomeIcon = (props) => <Svg {...props}><path d="M3 11 12 4l9 7v9H3z" /><path d="M9 20v-6h6v6" /></Svg>

export const DocumentIcon = (props) => <Svg {...props}><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5M10 13h6M10 17h6" /></Svg>

export const PeopleIcon = (props) => (
    <Svg {...props}>
        <circle cx="9" cy="8" r="3.5" />
        <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 4.5a3.5 3.5 0 0 1 0 7M21 20c0-2.6-1.6-4.8-4-5.6" />
    </Svg>
)

export const ChartIcon = (props) => <Svg strokeWidth={2.2} {...props}><path d="M5 20V12M10 20V6M15 20v-9M20 20V9" /></Svg>

export const EyeIcon = (props) => (
    <Svg size={20} strokeWidth={1.9} {...props}>
        <path d="M2 12c1-2.5 5-7 10-7s9 4.5 10 7c-1 2.5-5 7-10 7S3 14.5 2 12z" />
        <circle cx="12" cy="12" r="3" />
    </Svg>
)

export const EyeOffIcon = (props) => (
    <Svg size={20} strokeWidth={1.9} {...props}>
        <path d="M3 3l18 18M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.1A10 10 0 0 1 12 5c5 0 9 4.5 10 7-.4 1-1.2 2.3-2.4 3.5M6.6 6.6C4.5 8 3 10 2 12c1 2.5 5 7 10 7 1.6 0 3-.4 4.3-1" />
    </Svg>
)

export const AlertIcon = (props) => (
    <Svg size={18} {...props}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 8v5M12 16v.5" />
    </Svg>
)

export const MailIcon = (props) => (
    <Svg size={26} {...props}>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 7 9 6 9-6" />
    </Svg>
)

export const ArrowRightIcon = (props) => (
    <Svg size={18} strokeWidth={2.4} {...props}>
        <path d="M5 12h14M13 6l6 6-6 6" />
    </Svg>
)

export const CogIcon = (props) => (
    <Svg {...props}>
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M4.9 19.1 7 17M17 7l2.1-2.1" />
    </Svg>
)
